import { render, staticRenderFns } from "./ot-multi-select-autocomplete.vue?vue&type=template&id=10e885aa&scoped=true&"
import script from "./ot-multi-select-autocomplete.vue?vue&type=script&lang=ts&"
export * from "./ot-multi-select-autocomplete.vue?vue&type=script&lang=ts&"
import style0 from "./ot-multi-select-autocomplete.vue?vue&type=style&index=0&id=10e885aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e885aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
